import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=51c94608&scoped=true"
import script from "./Inicio.vue?vue&type=script&lang=js"
export * from "./Inicio.vue?vue&type=script&lang=js"
import style0 from "./Inicio.vue?vue&type=style&index=0&id=51c94608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c94608",
  null
  
)

export default component.exports